import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Abonnement / facturation — carte bancaire duotone */
export const BillingIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Bande magnétique menthe */}
      <rect x="2" y="9" width="20" height="3" fill="var(--equiply-icon-bg)" />
      {/* Contour carte */}
      <rect x="2" y="5" width="20" height="14" rx="2.5" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Numéro stylisé */}
      <path
        d="M5.5 15.5h3M11 15.5h2.5"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round"
      />
    </svg>
  ),
);
BillingIcon.displayName = "BillingIcon";
